import { ChevronRight, Tag } from 'lucide-react'
import { Link } from '@router'
import styles from './UntaggedCallout.module.css'

type Props = {
	count: number
}

// Prompt on the Activities landing for activities whose tagging was deferred.
// Renders nothing at zero, so it clears itself once the list is worked through.
export const UntaggedCallout = ({ count }: Props) => {
	if (count === 0) return null

	return (
		<Link href="/activities/untagged" className={styles.callout}>
			<Tag size={18} className={styles.icon} aria-hidden="true" />
			<span className={styles.text}>
				<span className={styles.label}>
					{count === 1
						? '1 activity needs tagging'
						: `${count} activities need tagging`}
				</span>
				<span className={styles.sub}>
					Tag {count === 1 ? 'it' : 'them'} so{' '}
					{count === 1 ? 'it appears' : 'they appear'} in the right
					collections.
				</span>
			</span>
			<ChevronRight
				size={18}
				className={styles.chevron}
				aria-hidden="true"
			/>
		</Link>
	)
}
